const topics = [
  { label: '动作大片', heat: '🔥 9.8万', desc: '高燃打斗·肾上腺素飙升', icon: 'ri-fire-line' },
  { label: '悬疑推理', heat: '🔥 8.5万', desc: '烧脑剧情·反转不断', icon: 'ri-search-eye-line' },
  { label: '科幻巨制', heat: '🔥 7.9万', desc: '震撼视效·未来世界', icon: 'ri-rocket-line' },
  { label: '喜剧合家欢', heat: '🔥 9.2万', desc: '爆笑解压·全家乐享', icon: 'ri-emotion-laugh-line' },
  { label: '爱情文艺', heat: '🔥 6.7万', desc: '浪漫感人·心动时刻', icon: 'ri-heart-line' },
  { label: '恐怖惊悚', heat: '🔥 5.4万', desc: '胆小慎入·极限刺激', icon: 'ri-ghost-line' },
  { label: '国产剧集', heat: '🔥 12.3万', desc: '热门国剧·追更不停', icon: 'ri-tv-line' },
  { label: '韩剧精选', heat: '🔥 8.8万', desc: '高分韩剧·甜蜜上头', icon: 'ri-star-line' },
  { label: '动漫番剧', heat: '🔥 10.1万', desc: '热血番剧·二次元狂欢', icon: 'ri-movie-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">热门分类</span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">话题标签 · 热度追踪</h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">全网最热影视分类实时更新，点击进入任意频道开启观影之旅</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#ranking"
              onClick={(e) => { e.preventDefault(); document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="group flex flex-col p-4 md:p-5 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-center gap-3 mb-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                  <i className={`${topic.icon} text-base`}></i>
                </span>
                <span className="font-semibold text-sm md:text-base text-foreground-900 whitespace-nowrap">{topic.label}</span>
              </div>
              <div className="flex items-center justify-between mt-auto">
                <span className="text-xs text-foreground-500">{topic.desc}</span>
                <span className="text-xs font-semibold text-primary-500 whitespace-nowrap">{topic.heat}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}